var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 94,
    viewBox: "0 0 85 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.9977 0H22.607C8.319 0 0 8.366 0 22.701V71.252C0 85.822 8.319 94 22.607 94H61.9977C76.516 94 84.6 85.822 84.6 71.252V22.701C84.6 8.366 76.516 0 61.9977 0Z",
    fill: "#8A92A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8992 21.8525C23.8862 21.8525 23.8757 21.8631 23.8757 21.876V21.876C23.8757 21.889 23.865 21.8995 23.8521 21.8996C21.8372 21.9123 20.2097 23.5524 20.2097 25.5655C20.2097 27.5865 21.85 29.2315 23.8757 29.2315H37.9242C39.9499 29.2315 41.5949 27.5865 41.5949 25.5138C41.5949 23.4975 39.9499 21.8525 37.9242 21.8525H23.8992ZM60.7239 50.4755H23.8757C21.85 50.4755 20.2097 48.8305 20.2097 46.8095C20.2097 44.7885 21.85 43.1388 23.8757 43.1388H60.7239C62.7449 43.1388 64.3899 44.7885 64.3899 46.8095C64.3899 48.8305 62.7449 50.4755 60.7239 50.4755ZM60.7239 71.9545H23.8757C22.4657 72.1425 21.1027 71.4375 20.3507 70.2625C19.5987 69.0405 19.5987 67.4895 20.3507 66.3145C21.1027 65.0925 22.4657 64.4345 23.8757 64.5755H60.7239C62.5992 64.7635 64.0139 66.3615 64.0139 68.2885C64.0139 70.1638 62.5992 71.7665 60.7239 71.9545Z",
    fill: "#8A92A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8919 16.8646C62.8833 15.5371 64.7632 15.2646 66.0907 16.256V16.256C67.4182 17.2474 67.6907 19.1273 66.6993 20.4548L22.4203 79.7454C21.4288 81.0729 19.549 81.3453 18.2215 80.3539V80.3539C16.894 79.3625 16.6215 77.4827 17.6129 76.1552L61.8919 16.8646Z",
    fill: "#ED7E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLead);
export default __webpack_public_path__ + "static/media/emptyLead.1b830447bcfc46278bcfc9b9845b1d4c.svg";
export { ForwardRef as ReactComponent };